import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'

type InfoTagProps = {
  text: string
}
export const InfoTag = ({ text }: InfoTagProps) => {
  return (
    <Tag
      icon={<ExclamationCircleOutlined />}
      style={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid var(--color-blue-40)',
        backgroundColor: 'var(--color-blue-10)',
        fontSize: 16,
        color: 'var(--color-gray-70)',
      }}
    >
      {text}
    </Tag>
  )
}
